import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import GoToHomePage from '../components/GoToHomePage';
import 'katex/dist/katex.min.css';
import { Link } from 'react-router-dom';


const CalculatorPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{`${t('calc.translate.calc_list_activity_name')} – ${t(
          'string.translate.name_ab'
        )} ${new Date().getFullYear()}`}</title>
      </Helmet>
      <GoToHomePage />
      <section className='calculator'>
        <h3 className='calculator__title'>{t('calc.translate.calc_list_activity_name')}</h3>
        <ul className='calculator__list'>
          <li className='calculator__item'>
            <div className='calculator__link calculator__description-item'>
              <h3 className='calculator__item-title'>
                {t('calc.translate.calc_list_info_title')}
              </h3>
              <p className='calculator__item-description'>
                {t('calc.translate.calc_list_info_descr')}
              </p>
            </div>
          </li>
          <li className='calculator__item calculator__item--1'>
            <Link className='calculator__link' to='/calculators/calculator-1'>
              <h3 className='calculator__item-title'>
                {t('calc.translate.mole_calc_list_name')}
              </h3>
              <p className='calculator__item-description'>
                {t('calc.translate.mole_calc_list_descr')}
              </p>
            </Link>
          </li>
          <li className='calculator__item calculator__item--2'>
            <Link className='calculator__link' to='/calculators/calculator-2'>
              <h3 className='calculator__item-title'>
                {t('calc.translate.concentrat_calc_name')}
              </h3>
              <p className='calculator__item-description'>
                {t('calc.translate.concentrat_calc_list_descr')}
              </p>
            </Link>
          </li>
          <li className='calculator__item calculator__item--3'>
            <Link className='calculator__link' to='/calculators/calculator-3'>
              <h3 className='calculator__item-title'>
                {t('calc.translate.deal_gas_calc_list_name')}
              </h3>
              <p className='calculator__item-description'>
                {t('calc.translate.deal_gas_calc_list_descr')}
              </p>
            </Link>
          </li>
        </ul>
      </section>
    </>
  );
};

export default CalculatorPage;